import {$, w} from './constants';
gsap.registerPlugin(ScrollTrigger);

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');

    gsap.registerPlugin(ScrollTrigger);
    //Timelines para animaciones
    const titles = gsap.timeline();

    //Títulos
	const getBlocksList = () =>{
		gsap.defaults({ease: "power3.out"});
		gsap.set(".animation-title", {y: 100, opacity: 0});
		ScrollTrigger.batch(".animation-title", {
			onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.10, grid: [1, 3]}, duration: 1, overwrite: true}),
			once: true
		});
			
		ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-title", {y: 0, opacity: 1}));
	}

    if( $('.animation-titles').length){
        titles.to('.animation-titles',{
            scrollTrigger : {
                trigger: ".animation-titles",
                scrub: true,
                start : "start-=200",
                end : `bottom 50%`,
                markers : false,
                once: true
            }
        }).call(getBlocksList);
    }

    // GRID a n i m a t i o n

const grid = gsap.timeline();
const getBatchBlocks = () => {
    gsap.defaults({ease: "power3.out"});
    gsap.set(".animation-grid-block", {y: 75, opacity: 0, scale: 0.9});
    ScrollTrigger.batch(".animation-grid-block", {
        onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, scale: 1, stagger: {each: 0.15, grid: [1, 4]}, duration: .5, overwrite: true}),
        once: true
    });
    
    ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animation-grid-block", {y: 0, scale: 1, opacity: 1}));
}
const animateFrom = (elem, direction) => {
    direction = direction || 1;
    var x = 0,
        y = direction * 100;
    if(elem.classList.contains("animation_reveal_fromLeft")) {
      x = -100;
      y = 0;
    }
    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";
    gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
      duration: 1.25, 
      x: 0,
      y: 0, 
      autoAlpha: 1, 
      ease: "expo", 
      overwrite: "auto"
    });
}
const hide = (elem) => {
    gsap.set(elem, {autoAlpha: 0});
}
 //GRID
 if( $('.animation_reveal').length ){
    gsap.utils.toArray(".animation_reveal").forEach(function(elem) {
        hide(elem); 
        ScrollTrigger.create({
          trigger: elem,
          onEnter: function() { animateFrom(elem) }, 
          once: true
        });
    });
}

if( $('.animation_grid').length ){
    grid.to('.animation_grid', {
        scrollTrigger : {
            trigger: ".animation_grid",
            scrub: true,
            start : "start-=200",
            end : `bottom+=100 50%`,
            markers : false
        }
    }).call(getBatchBlocks);
}

    //Cookies
    if(localStorage.getItem('lomas_angelopolis_cookie')){
        $('#cookies_lomas').addClass('hide');
    }else{
        $('#cookies_lomas').delay(1500).addClass('show');
        $('#cookies_accept').click(() => {
            localStorage.setItem('lomas_angelopolis_cookie', 'true');
            $('#cookies_lomas').removeClass('show');
            $('#cookies_lomas').addClass('hide');
            console.log('Acepto cookies');
        });
        $('#cookies_close').click(() => {
            localStorage.setItem('lomas_angelopolis_cookie', 'true');
            $('#cookies_lomas').removeClass('show');
            $('#cookies_lomas').addClass('hide');
            console.log('Acepto cookies');
        });

    }

});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    //Scroll en links de misma página
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 70
                }, 1000);
            }
        }
    });

    const nav = $(".header");
    /* MENU: Scroll (Desktop) */
    w.scroll(function (event) {
        if($(this).scrollTop() > nav.height()){
            nav.addClass('active');
        }else{
            nav.removeClass('active ');
        }
        if($(this).scrollTop() > 0){
            $('.menu-item-has-children').children('.sub-menu').removeClass('active');
        }
    });
    $('.menu-item-has-children').click(function(){
        $(this).children('.sub-menu').toggleClass('active');
    })
    /* MENU: Mobile */
    $('#menu_mobile_trigger').click(function(){
        nav.addClass('active');
        $(this).addClass('inactive');
        $('#menu_mobile_trigger_close').addClass('active');
        $('#menu_mobile_aside').addClass('active');
    });
    $('#menu_mobile_trigger_close').click(function(){
        $(this).removeClass('active');
        $('#menu_mobile_trigger').removeClass('inactive');
        $('#menu_mobile_aside').removeClass('active');
        $('.menu-item-has-children').children('.sub-menu').removeClass('active');
    })

    /* HERO: Slider */

    if( $('#slider_hero').length ){
        $('#slider_hero').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 7000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-hero',
            appendDots: $('.dots-hero-container > .container')
        })
    }

    
    /* ACERCA: Slider */

    if( $('#slider_acerca').length ){
        $('#slider_acerca').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-acerca-container')
        })
    }

     /* MÁS INFO: Slider */

     if( $('#slider_mas').length ){
        $('#slider_mas').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-more-container')
        })
    }

    /* INFORMACIÓN: Slider */

    if( $('#slider_information').length ){
        $('#slider_information').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-information-container')
        })
    }

    /* ESTILO: Animación */
    
    const life_st = gsap.timeline();

    if( $('#animation_lifestyle').length ){

        let counters = document.querySelectorAll('p.animate-count');

        life_st.to('#animation_lifestyle', {
            scrollTrigger : {
                trigger: '#animation_lifestyle',
                start: 'start-=200 50%',
                end: 'bottom 50%',
                once: true,
                onEnter: () => {
                    counters.forEach(element => {
                        console.log(element);
                        let end_t = $(element).data('count');
                        let num = element.innerText.replace(/\,/g,'')
                        element.innerText = num;
                        life_st.to(element, {
                            duration: 1, 
                            innerText: end_t, 
                            modifiers:{
                              innerText:function(innerText){
                                return  gsap.utils.snap(2, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                              }
                            },
                            ease:"power1"}, "-=0.1");
                    })
                }
            }
        })

        

    }

    /* LOTES: Slider */

    if( $('#slider_lotes').length ){
        var swiper = new Swiper('.swiper', {
            slidesPerView: 1.9,
            //spaceBetween: 50,
            centeredSlides: true,
            speed:800,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            slideToClickedSlide: true,
            autoplay: {
                delay: 5000,
            }
        });
    }

     /* ZONAS: Slider */

     if( $('#slider_zonas').length ){
        $('#slider_zonas').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-zonas-container >.dots-zonas-aux > .block')
        })
    }

    /* LOGOS: Slider */
    if( $('#slider_logos').length ){
        $('#slider_logos').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: false,
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-artistas-container'),
            responsive: [
                {
                    breakpoint: 951,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 651,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    }
                }
            ]
        })
    }

    /* SINGLE : Hover Amenidades */
    if( w.width() > 950 ) {
        $('.single__amenities-list-titles-block').hover(function() {
            console.log('hover')
            let image = $(this).data('image');
            let target = $('.single__amenities-list-images').find(`div[data-image="${image}"]`);
            $(target).addClass('active');
            $(target).parent().addClass('active');
        },function(){
            let image = $(this).data('image');
            let target = $('.single__amenities-list-images').find(`div[data-image="${image}"]`);
            $(target).removeClass('active');
            $(target).parent().removeClass('active');
        });
    }

    /* MACROLOTES: Slider Acerca */

    /* ZONAS: Slider */

    if( $('#slider_about_macrolotes').length ){
        $('#slider_about_macrolotes').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-macrolotes-container >.dots-macrolotes-aux > .block')
        })
    }

    if( $('#slider_macrolotes_acerca').length ){
        $('#slider_macrolotes_acerca').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-acerca-macrolotes-container')
        })
    }

    /* MACROLOTES: Slider Artistas */

    if( $('#slider_artists').length ){
        $('#slider_artists').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: false,
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-artistas-container'),
            responsive: [
                {
                    breakpoint: 951,
                    settings: {
                      slidesToShow: 2,
                    }
                }
              ]
        })
    }

    /* DESARROLLADOR Animación */
    /* ESTILO: Animación */
    
    const counter_h = gsap.timeline();

    if( $('#animate_counters_horizontal').length ){

        let counters = document.querySelectorAll('p.animate_counter_h');

        counter_h.to('#animate_counters_horizontal', {
            scrollTrigger : {
                trigger: '#animate_counters_horizontal',
                start: 'start-=200 50%',
                end: 'bottom 50%',
                once: true,
                onEnter: () => {
                    counters.forEach(element => {
                        console.log(element);
                        let end_t = $(element).data('counter');
                        let num = element.innerText.replace(/\,/g,'')
                        element.innerText = num;
                        life_st.to(element, {
                            duration: 2, 
                            innerText: end_t, 
                            modifiers:{
                              innerText:function(innerText){
                                return  gsap.utils.snap(2, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                              }
                            },
                            ease:"power1"}, "-=1.3");
                    })
                }
            }
        })

        

    }

    /* DESARROLADOR: Slider */

    if( $('#slider_grupo').length ){
        $('#slider_grupo').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-acerca',
            appendDots: $('.dots-acerca-container')
        })
    }

    /* FORMULARIO: General*/
     //Contacto
     $("#contact").validate({
        rules: {
            name : {
                required: true
            },
            phone : {
                number: true
            },
            email: {
                required: true,
                email: true
            }
        },
        messages : {
            name: {
                required: "Este campo es obligatorio"
            },
            phone: {
                number: "Por favor ingrese solo números"
            },
            email: {
                required: "Este campo es obligatorio",
                email: "Ingresa una dirección de correo válida"
            }
        },
        errorClass : "error-contact",
        errorElement: "label",
        submitHandler: function(form) {
            event.preventDefault();
            $('#submit').prop('disabled', true);
			$('#success').removeClass('fadeOut');
            $.ajax({
                url: cltvo_js_vars.ajax_url,
                type: form.method,
                data: $(form).serialize(),
                success: function(response) {
                    $('#name').val('');
                    $('#phone').val('');
                    $('#email').val('');
                    $('#submit').prop('disabled', true);
                    $('#success').html('¡Gracias! Nos comunicaremos contigo a la brevedad');
                    $('#success').addClass('fadeOut');
                },
                error: function( error ){
                    $('#error').text( error.responseJSON.message );
                }
            });
        }
    });
})
